import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../core/api-config';

// File upload service.
@Injectable({ providedIn: 'root' })
export class FileUploadService {
  constructor(private http: HttpClient) {}

  // Upload a single file to backend local folder.
  uploadSingleFile(file: File, entityType: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entityType', entityType);
    return this.http.post<any>(  `${ApiConfig.baseUrl}/files/upload`, formData);
  }


  
}
